var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"fill":"none","stroke":"currentColor","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2","d":"M3 10h10a8 8 0 018 8v2M3 10l6 6m-6-6l6-6"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }